/** @format */
import React, { FunctionComponent } from 'react';

import { JourneyBoundary } from '../journey-boundary';
import { FanSection } from './components/fan-section';
import { ModelJourneyFanProps } from './config/types';

export * from './config/constants';
export type { ModelJourneyFanProps } from './config/types';

/**
 * How customers transact with the model being viewed, dealt out as two hands of
 * playing cards either side of it: what they owned before, what they bought
 * after.
 *
 * The section is wrapped in its own error boundary, so this experiment on a
 * page that sells things cannot take the page down if it fails to render.
 */
export const ModelJourneyFan: FunctionComponent<ModelJourneyFanProps> = (
    props
) => (
    <JourneyBoundary>
        <FanSection {...props} />
    </JourneyBoundary>
);
